import { createContext, useCallback, useContext, useState } from "react";

const RefreshContext = createContext({
  refreshKey: 0,
  lastNotification: null,
  triggerRefresh: () => {},
});

export function RefreshProvider({ children }) {
  const [refreshKey, setRefreshKey] = useState(0);
  const [lastNotification, setLastNotification] = useState(null);

  const triggerRefresh = useCallback((payloadData = null) => {
    if (payloadData) setLastNotification({ at: Date.now(), data: payloadData });
    setRefreshKey((k) => k + 1);
  }, []);

  return (
    <RefreshContext.Provider value={{ refreshKey, lastNotification, triggerRefresh }}>
      {children}
    </RefreshContext.Provider>
  );
}

export function useRefresh() {
  return useContext(RefreshContext);
}
